import { render, staticRenderFns } from "./DoctorOrderView.vue?vue&type=template&id=e193e90a&scoped=true"
import script from "./DoctorOrderView.vue?vue&type=script&lang=js"
export * from "./DoctorOrderView.vue?vue&type=script&lang=js"
import style0 from "./DoctorOrderView.vue?vue&type=style&index=0&id=e193e90a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e193e90a",
  null
  
)

export default component.exports